import React,{useState} from 'react'
import "./TechStack.css"
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';

const TechStack = () => {
    const data=[
        {
            name: "Full Stack Developer"
        },
        {
            name: "Node js"
        },
        {
            name: "React js"
        },
        {
            name: "Vue js"
        },
        {
            name: "Express js"
        },
        {
            name: "Nuxt js"
        },
        {
            name: "Angular js"
        },
        {
            name: "Vanila js"
        },
        {
            name: "Javscript"
        },
        {
            name: "Typescript"
        },
        {
            name: "Python"
        },
        {
            name: "Django"
        },
        {
            name: "Java"
        },
        {
            name: "UI/UX"
        },
        {
            name: "HTML/CSS"
        },
       
    ];

const colors = [
    "#F1C40F",
    "#4287f5",
    "#ff0000",
    "#ff8080",
    "#bfff00",
    "#ff00bf",
    "#00ffff",
    " #ff5500",
    " #0a0f0f ",
    " #b3cccc",
    "#808080",
    "#999966",
    "#997366",
    " #ffbf00",
    "#706b5c",

];

const [showMoreTechStack, setShowMoreTechStack] = useState(6);

const loadMore = () => {
    setShowMoreTechStack((prev) => prev + 3);
};

  return (
    <div className="container techstack-section">

    <div className="section-title" id="techstack">
        <h5>Tech Stack</h5>
        <span className="line"></span>
    </div>
    <div className="row">

     {data.slice(0, showMoreTechStack).map((item, index) => (

        <Fade right>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12" key={index}>

          <div className={index===0?"tech-content-marked tech-content":"tech-content"}>
          <span className="tech-number" 
          style={{backgroundColor: colors[index]}}>
            {index + 1}
          </span>
          <p>{item.name}</p>
          </div>
        </div>
        </Fade>
     ))}
    </div>


    {showMoreTechStack >= data.length ? null: (
   <Zoom>
    <span className="load-more-tech-stack" onClick={loadMore}>
        Load More
    </span>
    </Zoom>
)} 
    </div>
  );
};

export default TechStack